export default {
  openGraph: {
    type: "website",
    locale: "fr_FR",
    url: "https://www.easycapital.fr/",
    site_name:
      "Outil de gestion de patrimoine - Easy Capital, cabinet à Bordeaux",
  },
};
